import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { DynPopup } from "../../../Components/DynPopup";
import { TextComponent } from "../../../Components/TextComponent";
import { WidgetWhoIsOnline } from "../Widgets/WidgetWhoIsOnline";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";
import { MsoTable } from "../../Table/MsoTable";
import { EditTypes } from "../../Table/EditTypes";
import { TableColumnTypes } from "../../Table/TableColumnTypes";
import { ITableColumn } from "../../Table/ITableColumn";
import { TableColumnAlign } from "../../Table/TableColumnAlign";
import { REFUSED } from "dns";

export type PopupWhoIsOnlineComponentProps = {
    widget: WidgetWhoIsOnline;
}

export class PopupWhoIsOnlineComponent extends JSXComponent {
    props: PopupWhoIsOnlineComponentProps;
    title: LanguageStringComponent;

    constructor(props: PopupWhoIsOnlineComponentProps) {
        super(props);
    }

    onSave = (): boolean => {
        if (this.title.props.model == null)
            this.title.props.model = new LanguageString();
        this.props.widget.props.title = this.title.props.model;
        this.props.widget.recreate();
        return true;
    }

    private Columns: ITableColumn[] = [
        { type: TableColumnTypes.String, dataField: "name", number: 1, width: 330, headerCssClass: "flex-grow-1", headerText: Resources.Common.labelName, align: TableColumnAlign.Left },
        { type: TableColumnTypes.Date, useTime: true, dataField: "lastLogin", number: 2, width: 330, headerCssClass: "flex-grow-1", headerText: Resources.Common.lastLogin, align: TableColumnAlign.Left },
    ]

    element: HTMLElement =
        <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetWhoIsOnline}>
            {this.renderTitle()}
            <div style={{ height: "10rem" }}>
                <label className="form-label">{Resources['WidgetClient'].OnlineLog}</label>
                {this.renderUsers()}
            </div>
        </DynPopup>

    renderTitle(): HTMLElement {
        this.title = new LanguageStringComponent({
            model: this.props.widget.props.title,
            name: Resources['WidgetClient'].title,
            additionalCssClasses: "name-in-languages",
            maxLength: 250,
            showLabel: true,
            alwaysExpanded: false
        }); 
        return this.title.render();
    }

    renderUsers(): HTMLElement {
        let users = (app.onlineUserManager).onlineUers;
        let div: HTMLElement = <div className="mso-online-table pb-3"></div>;

        let table = new MsoTable(div, {
            loadOnCreate: false,
            rowsPerPage: 100,
            fixedLayout: false,
            idField: "id",
            settingsName: "onlineList",
        });

        table.createAll(this.Columns, users, null, null);
        return div;
    }

    render(): HTMLElement {
        return this.element;
    }
}
